import React from 'react';
import {
  HomeOutlined,
  HddOutlined,
  TeamOutlined,
  ProfileOutlined,
  UserOutlined,
  SolutionOutlined,
  ReconciliationOutlined,
} from '@ant-design/icons';

export const Routes = [
  {
    title: 'Home',
    slug: 'home',
    path: '/',
    icon: <HomeOutlined />,
    roles: ['admin', 'Dev'],
    childs: [],
    optionalIcon: true,
  },
  {
    title: 'Usuarios',
    slug: 'users',
    path: '/users',
    icon: <TeamOutlined className="anticon" />,
    roles: ['admin', 'Dev'],
    childs: [],
    optionalIcon: true,
  },
  {
    title: 'Clientes',
    slug: 'clients',
    path: '/clients',
    icon: <UserOutlined />,
    roles: ['admin', 'Dev', 'level_1'],
    childs: [],
    optionalIcon: true,
  },

  {
    title: 'Papeles',
    slug: 'papers',
    path: '/papers',
    icon: <ReconciliationOutlined />,
    roles: ['admin', 'Dev', 'level_1'],
    childs: [],
    optionalIcon: true,
  },

  {
    title: 'Reportes',
    slug: 'reports',
    path: '/reports',
    icon: <SolutionOutlined />,
    roles: ['admin', 'Dev', 'level_1'],
    childs: [],
    optionalIcon: true,
  },

  {
    title: 'Catalogos',
    slug: 'catalogs',
    path: '',
    icon: <ProfileOutlined />,
    roles: ['admin', 'Dev'],
    childs: [
      {
        title: 'Regimenes',
        slug: 'regimes',
        path: '/regimes',
        icon: <HddOutlined />,
        roles: ['admin', 'Dev', 'level_1'],
        childs: [],
        optionalIcon: true,
      },
      {
        title: 'Roles',
        slug: 'roles',
        path: '/roles',
        icon: <HddOutlined />,
        roles: ['admin', 'Dev'],
        childs: [],
        optionalIcon: true,
      },
    ],
    optionalIcon: true,
  },
];
